import { SceneController } from './controller/SceneController';

new SceneController(window);
